/**
 * `/market/library` — the packs this account HAS (M4d).
 *
 * The route file carries no logic on purpose: the gateway answers an id that names
 * nothing, an id belonging to somebody else and a malformed id with one body and one
 * status, so a client-side check would only give the three answers different shapes.
 */
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/market/library')({});
